import { type ReactNode } from 'react';
import { Input } from '@/components/ui/input';
import { ColorPicker } from '@/components/ui/color-picker';
import { validateEthAddress } from '../utils/approacher-helpers';
import { RelinkManychatButton } from './relink-manychat-button';

type Form = {
  manychat_subscriber_id: string;
  usdc_wallet: string;
  is_active: boolean;
};

type Props = {
  f: Form;
  set: (k: keyof Form, v: string | boolean) => void;
};

type ManyChatProps = Props & {
  memberId: string;
  onCleared?: (() => void) | undefined;
};

export function ManyChatField({
  f,
  set,
  memberId,
  onCleared,
}: ManyChatProps): ReactNode {
  return (
    <div className="col-span-2">
      <Input
        label="ManyChat ID"
        value={f.manychat_subscriber_id}
        onChange={(e) => set('manychat_subscriber_id', e.target.value)}
      />
      <div className="mt-xs flex justify-end">
        <RelinkManychatButton
          memberId={memberId}
          hasManychatId={!!f.manychat_subscriber_id}
          onCleared={onCleared}
        />
      </div>
    </div>
  );
}

export function WalletField({ f, set }: Props): ReactNode {
  const val = f.usdc_wallet;
  const ok = !val || validateEthAddress(val);
  return (
    <div className="col-span-2">
      <Input
        label="Billetera USDC (Ethereum)"
        value={val}
        onChange={(e) => set('usdc_wallet', e.target.value)}
        error={ok ? '' : 'Dirección inválida'}
        placeholder="0x..."
      />
      <p className="mt-1 text-[10px] text-text-tertiary">
        Ej: 0x1234...abcd (42 caracteres)
      </p>
    </div>
  );
}

export function ActiveToggle({ f, set }: Props): ReactNode {
  return (
    <label className="col-span-2 flex cursor-pointer items-center gap-sm text-sm text-text-secondary">
      <input
        type="checkbox"
        checked={f.is_active}
        onChange={(e) => set('is_active', e.target.checked)}
        className="h-4 w-4 accent-brand-red"
      />{' '}
      Activo
    </label>
  );
}

type ColorProps = {
  value: string;
  onChange: (next: string) => void;
};

export function ColorField({ value, onChange }: ColorProps): ReactNode {
  return (
    <div className="col-span-2 space-y-xs">
      <label className="block text-xs font-medium text-text-secondary">
        Color de acento
      </label>
      <ColorPicker value={value} onChange={onChange} />
    </div>
  );
}
